/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function macOS() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'macOS',
				config: {
					ruleType: "os",
					args: {
						os: ["macos"]
					},
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			macOS
			operating
			systems.
		</p>
	</>;
}
